(function () {
    'use strict';

    var module = angular.module('uwAgenda.email');
    module.controller('DetailShowEmailController', ['$uibModalInstance', 'Email', 'email', DetailShowArticleControllerFn]);

    /* controlle for email modal */
    function DetailShowArticleControllerFn($uibModalInstance, Email, email) {
        var vm = this;

        activate();

        // cancel modal
        vm.cancel = function () {
            $uibModalInstance.dismiss("abort");
        };

        /* activation work */
        function activate() {
            var mail = new Email();

            // extend email
            mail.extend(email);
            // prepare for view
            mail.prepareView();
            // set created email
            vm.email = mail;
        }
    }
})();